import { SponsorModel } from "ts-core";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useBalloonEventsOptions } from "../contexts/EmbedOptions";
import { trackMixpanel } from "../utils/mixpanel";

function Zeppelin({
  sponsor,
  onAnimationEnd,
}: {
  sponsor: SponsorModel;
  onAnimationEnd: (e: React.AnimationEvent<HTMLDivElement>) => void;
}) {
  const [bottom, setBottom] = useState(getRandomBottom());

  function getRandomBottom() {
    return (Math.random() * 20 + 40).toString() + "%";
  }

  useEffect(() => {
    setBottom(getRandomBottom());
  }, [sponsor]);

  return (
    <div
      style={{
        bottom,
      }}
      className="absolute w-full pointer-events-none overflow-hidden"
    >
      <div
        onAnimationIteration={onAnimationEnd}
        className="animate-move-right flex"
      >
        {sponsor.partnerCode ? (
          <Link
            className="pointer-events-auto animate-float"
            to={"/partner/" + sponsor.partnerCode}
            onClick={() => {
              trackMixpanel("Zeppelin", "Click", {
                sponsorId: sponsor.id,
                sponsorName: sponsor.name,
              })
            }}
          >
            <img className="lg:w-[150pt] w-[100pt]" src={sponsor.zeppelinImage} />
          </Link>
        ) : (
          <a
            className="pointer-events-auto animate-float"
            href={sponsor.websiteUrl || '#'}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => {
              trackMixpanel("Zeppelin", "Click", {
                sponsorId: sponsor.id,
                sponsorName: sponsor.name,
              })
            }}
          >
            <img className="lg:w-[150pt] w-[100pt]" src={sponsor.zeppelinImage} />
          </a>
        )}
      </div>
    </div>
  );
}

export function ZeppelinContainer({ sponsors }: { sponsors: SponsorModel[] }) {
  const [sponsorIndex, setSponsorIndex] = useState(0);
  const [currentSponsor, setCurrentSponsor] = useState<SponsorModel | null>(
    sponsors.length > 0 ? sponsors[getNextSponsorIndex()] : null
  );

  function getNextSponsorIndex() {
    //const r = Math.floor(Math.random() * sponsors.length);
    //return r;
    return (sponsorIndex + 1) % sponsors.length;
  }

  useEffect(() => {
    if (sponsors.length === 0) {
      setCurrentSponsor(null);
      return;
    }
    if (sponsorIndex >= sponsors.length) {
      setSponsorIndex(getNextSponsorIndex());
    } else if (
      currentSponsor == null ||
      currentSponsor.id !== sponsors[sponsorIndex].id
    ) {
      setCurrentSponsor(sponsors[sponsorIndex]);
    }
  }, [sponsorIndex, sponsors]);

  function onAnimationEnd(e: React.AnimationEvent<HTMLDivElement>) {
    if (e.animationName === "move-right")
      setSponsorIndex(getNextSponsorIndex());
  }

  if (!currentSponsor) return null;

  return <Zeppelin onAnimationEnd={onAnimationEnd} sponsor={currentSponsor} />;
}
